import React, { useState } from "react";
import styles from "./Application.module.css";
import { Typography } from "@mui/material";
import AppButton from "component/button/AppButton";
import { useNavigate } from "react-router";
import { ClockIcon } from "assets/images";
import { convertToLocaleString } from "utils/helpers";
import ModalLayout from "component/modalLayout/ModalLayout";
import Reason from "./modals/Reason";

function Application({
  handleMakePayment,
  application,
  handleCompleteApplication,
}) {
  const navigate = useNavigate();
  const [openReason, setOpenReason] = useState(false);

  return (
    <div className={styles.application}>
      {
        <div className={styles.approval_tab}>
          <div
            className={`${styles.dot} ${
              application.submitted &&
              application.paid === false &&
              application.submittedDocuments === 1 &&
              styles.dot_payment
            } ${
              application.submitted &&
              application.submittedDocuments === 0 &&
              styles.dot_document
            }   ${application.submitted === false && styles.dot_unsubmitted} ${
              application.status === "approved" && styles.dot_approved
            } ${application.status === "rejected" && styles.dot_rejected} 
            ${
              application.status === "pending" &&
              application.submitted &&
              application.paid &&
              styles.dot_payment
            } `}
          ></div>
          <div className={styles.approval}>
            <div className={styles.approval_left}>
              <div className={styles.approval_heading}>
                <div
                  className={`${styles.clock} ${
                    application.submitted &&
                    application.paid === false &&
                    application.submittedDocuments === 1 &&
                    styles.clock_payment
                  }  ${
                    application.submitted === false && styles.clock_unsubmitted
                  } ${
                    application.submitted &&
                    application.submittedDocuments === 0 &&
                    styles.clock_document
                  } ${
                    application.status === "approved" && styles.clock_approved
                  }  ${
                    application.status === "rejected" && styles.clock_rejected
                  } ${
                    application.status === "pending" &&
                    application.submitted &&
                    application.paid &&
                    styles.clock_payment
                  } `}
                >
                  {application.submitted &&
                    application.paid === false &&
                    application.submittedDocuments === 1 && (
                      <ClockIcon color="#DAB328" />
                    )}
                  {application.submitted === false && (
                    <ClockIcon color="#0072ce" />
                  )}
                  {application.submitted &&
                    application.submittedDocuments === 0 && (
                      <ClockIcon color="#9199A8" />
                    )}
                  {application.status === "approved" && (
                    <ClockIcon color="#31BD8B" />
                  )}
                  {application.status === "rejected" && (
                    <ClockIcon color="#DA2828" />
                  )}
                  {application.status === "pending" &&
                    application.submitted &&
                    application.paid && <ClockIcon color="#DAB328" />}
                </div>

                {application.submitted &&
                  application.paid &&
                  application.submittedDocuments === 1 && (
                    <Typography
                      style={{
                        color:
                          (application.status === "pending" && "#DAB328") ||
                          (application.status === "approved" && "#31BD8B") ||
                          (application.status === "rejected" && "#DA2828"),
                      }}
                    >
                      {application?.status} application
                    </Typography>
                  )}

                {application.submitted === false && (
                  <Typography style={{ color: "#0072ce" }}>
                    Unsubmitted Application
                  </Typography>
                )}
                {application.submitted &&
                  application.paid === false &&
                  application.submittedDocuments === 1 && (
                    <Typography style={{ color: "#DAB328" }}>
                      Payment pending
                    </Typography>
                  )}
                {application.submitted &&
                  application.submittedDocuments === 0 && (
                    <Typography style={{ color: "#9199A8" }}>
                      Incomplete Document
                    </Typography>
                  )}
              </div>
              <div className={styles.application_id}>
                <Typography>
                  Application ID: {application?.applicationId}
                </Typography>
              </div>
            </div>

            <div className={styles.approval_right}>
              {application.submitted === false && (
                <div className={styles.application_btn}>
                  <AppButton
                    handleAction={() => {
                      handleCompleteApplication(application);
                    }}
                    width={"180px"}
                    textColor="#FFFFFF"
                    btnBg="#0072CE"
                    btnText="Complete your Application"
                  />
                </div>
              )}
              {application.submitted &&
                application.submittedDocuments === 1 &&
                application.paid === false && (
                  <div className={styles.application_btn}>
                    <AppButton
                      handleAction={() => {
                        handleMakePayment(application);
                      }}
                      width={"180px"}
                      textColor="white"
                      btnBg="#DAB328"
                      btnText="Make Payment"
                    />
                  </div>
                )}
              {application.submitted &&
                application.submittedDocuments === 0 &&
                application?.status !== "approved" && (
                  <div className={styles.application_btn}>
                    <AppButton
                      handleAction={() => {
                        navigate("/documents");
                      }}
                      width={"180px"}
                      textColor="#FFFFFF"
                      btnBg="#0072CE"
                      btnText="Upload Documents"
                    />
                  </div>
                )}
              {application.submitted &&
                application.submittedDocuments === 1 &&
                application.paid &&
                application.status === "rejected" && (
                  <div className={styles.application_btn}>
                    <AppButton
                      handleAction={() => {
                        setOpenReason(true);
                      }}
                      width={"180px"}
                      textColor="#FFFFFF"
                      btnBg="#0072CE"
                      btnText="View Rejection Note"
                    />
                  </div>
                )}
            </div>
          </div>
        </div>
      }

      <div className={styles.application_details}>
        <table>
          <thead>
            <tr>
              <th>Date Submitted</th>
              <th>Application Category</th>
              <th>Property Type</th>
              <th>Property Price</th>
              <th>Equity Contribution</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td> {new Date(application.createdAt).toLocaleDateString()}</td>
              <td style={{ textTransform: "capitalize" }}>
                {application.category || "NA"}
              </td>
              <td style={{ textTransform: "capitalize" }}>
                {application.propertyType || "NA"}
              </td>
              <td>₦ {convertToLocaleString(application.propertyPrice) || 0}</td>
              <td>
                ₦{" "}
                {convertToLocaleString(
                  application.propertyEquityContribution
                ) || 0}
              </td>
            </tr>
          </tbody>

          <thead>
            <tr>
              <th className={styles.bank_info_head}>Account Number</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{application?.bankAccount || "NA"}</td>
            </tr>
          </tbody>
        </table>
      </div>

      {openReason && (
        <ModalLayout
          width={"420px"}
          openModal={openReason}
          children={
            <Reason
              application={application}
              handleClose={() => {
                setOpenReason(false);
              }}
            />
          }
          title="Rejection Note"
          handleClose={() => {
            setOpenReason(false);
          }}
        />
      )}
    </div>
  );
}

export default Application;